[
  {
    "code": "HN-AT",
    "name": "Atlántida"
  },
  {
    "code": "HN-CH",
    "name": "Choluteca"
  },
  {
    "code": "HN-CL",
    "name": "Colón"
  },
  {
    "code": "HN-CM",
    "name": "Comayagua"
  },
  {
    "code": "HN-CP",
    "name": "Copán"
  },
  {
    "code": "HN-CR",
    "name": "Cortés"
  },
  {
    "code": "HN-EP",
    "name": "El Paraíso"
  },
  {
    "code": "HN-FM",
    "name": "Francisco Morazán"
  },
  {
    "code": "HN-GD",
    "name": "Gracias a Dios"
  },
  {
    "code": "HN-IN",
    "name": "Intibucá"
  },
  {
    "code": "HN-IB",
    "name": "Islas de la Bahía"
  },
  {
    "code": "HN-LP",
    "name": "La Paz"
  },
  {
    "code": "HN-LE",
    "name": "Lempira"
  },
  {
    "code": "HN-OC",
    "name": "Ocotepeque"
  },
  {
    "code": "HN-OL",
    "name": "Olancho"
  },
  {
    "code": "HN-SB",
    "name": "Santa Bárbara"
  },
  {
    "code": "HN-VA",
    "name": "Valle"
  },
  {
    "code": "HN-YO",
    "name": "Yoro"
  }
]